import apiClient from "./axios"

// Get all customer cities with optional filtering
export const getCustomerCities = async (params = {}) => {
  const { data } = await apiClient.get("/customer-cities", { params })
  return data
}

// Get a specific customer city by ID
export const getCustomerCity = async id => {
  const { data } = await apiClient.get(`/customer-cities/${id}`)
  return data
}

// Create a new customer city
export const createCustomerCity = async cityData => {
  const { data } = await apiClient.post("/customer-cities", cityData)
  return data
}

// Update an existing customer city
export const editCustomerCity = async ({ id, ...cityData }) => {
  const { data } = await apiClient.patch(`/customer-cities/${id}`, cityData)
  return data
}

// Delete a customer city (soft delete)
export const deleteCustomerCity = async id => {
  const { data } = await apiClient.delete(`/customer-cities/${id}`)
  return data
}

// Get all customer cities without pagination
export const getAllCustomerCities = async (params = {}) => {
  const { data } = await apiClient.get("/customer-cities", {
    params: { ...params, all: true },
  })
  return data
}

// Search customer cities by name or slug
export const searchCustomerCities = async (searchTerm, params = {}) => {
  const { data } = await apiClient.get("/customer-cities", {
    params: { ...params, search: searchTerm },
  })
  return data
}

// Get trashed customer cities
export const getTrashedCustomerCities = async (params = {}) => {
  const { data } = await apiClient.get("/customer-cities/trashed", { params })
  return data
}

// Get a customer city by slug
export const getCustomerCityBySlug = async slug => {
  const { data } = await apiClient.get(`/customer-cities/slug/${slug}`)
  return data
}

// Restore a trashed customer city
export const restoreCustomerCity = async id => {
  const { data } = await apiClient.post(`/customer-cities/${id}/restore`)
  return data
}
